export default {
  "content": "<path d=\"M13.207 15.793l-1.414 1.414-5-5 1.414-1.414 5 5zM14 7.879a1.5 1.5 0 112.121 2.12 1.5 1.5 0 01-2.12-2.12z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.132 2.009l8 1.062.164.036c.37.115.647.437.696.832l1 7.936a1 1 0 01-.294.84l-9.735 9.5a1 1 0 01-1.405-.008l-8.765-8.765a1 1 0 01-.009-1.405l9.5-9.735a1 1 0 01.848-.293zM3.905 12.727l7.368 7.367 8.672-8.463-.841-6.679-6.739-.895-8.46 8.67z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};